(function () {
  function isAniversarioActive() {
    return true;
  }

  function isLogged() {
    try {
      var api = window.KrowAccess || window.CrowAccess || window.CrowerAccess;
      if (api && api.isLogged) return !!api.isLogged();
      return (
        localStorage.getItem('krow_logged') === 'true' ||
        localStorage.getItem('crow_logged') === 'true' ||
        localStorage.getItem('crower_logged') === 'true'
      );
    } catch (_) {
      return false;
    }
  }

  function shouldShowAniversario() {
    return isAniversarioActive() && isLogged();
  }

  var CONFETTI_COLORS = ['#0a2a5e', '#d4af37', '#f0d78c', '#1e63d0', '#e8b923'];
  var CONFETTI_COUNT = 45;
  var CONFETTI_BATCH_MS = 12000;   // duration of one piece batch (matches max animation)

  var BALLOON_DATA = [
    { left: '4%',  top: '20%', color: '#d4af37', delay: 0 },
    { left: '88%', top: '30%', color: '#0a2a5e', delay: 1.5 },
    { left: '10%', top: '60%', color: '#e8b923', delay: 3 },
    { left: '92%', top: '70%', color: '#1e63d0', delay: 2 },
  ];

  function spawnConfettiBatch() {
    var old = document.querySelector('.pt-aniv-confetti');
    if (old) old.remove();
    var wrap = document.createElement('div');
    wrap.className = 'pt-aniv-confetti';
    document.body.appendChild(wrap);
    for (var i = 0; i < CONFETTI_COUNT; i++) {
      var size = 6 + Math.random() * 8;
      var isCircle = Math.random() > 0.5;
      var p = document.createElement('div');
      p.className = 'pt-aniv-confetti-piece';
      p.style.left = (Math.random() * 100) + 'vw';
      p.style.width = size + 'px';
      p.style.height = (isCircle ? size : size * 0.5) + 'px';
      p.style.borderRadius = isCircle ? '9999px' : '2px';
      p.style.background = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
      p.style.animationDelay = (Math.random() * 6) + 's';
      p.style.animationDuration = (5 + Math.random() * 6) + 's';
      p.style.setProperty('--pt-aniv-drift', (Math.random() * 80 - 40) + 'px');
      p.style.setProperty('--pt-aniv-rotate', (Math.random() * 720 - 360) + 'deg');
      wrap.appendChild(p);
    }
    return wrap;
  }

  function injectConfetti() {
    // Continuous: respawns a fresh batch every CONFETTI_BATCH_MS, never pauses.
    function tick() {
      spawnConfettiBatch();
      setTimeout(tick, CONFETTI_BATCH_MS);
    }
    tick();
  }

  function injectBalloons() {
    if (document.querySelector('.pt-aniv-balloons')) return;
    var wrap = document.createElement('div');
    wrap.className = 'pt-aniv-balloons';
    document.body.appendChild(wrap);

    BALLOON_DATA.forEach(function (b) {
      var balloon = document.createElement('div');
      balloon.className = 'pt-aniv-balloon';
      balloon.style.left = b.left;
      balloon.style.top = b.top;
      balloon.style.animationDelay = b.delay + 's';

      var body = document.createElement('div');
      body.className = 'pt-aniv-balloon-body';
      body.style.background = b.color;

      var shine = document.createElement('span');
      shine.className = 'pt-aniv-balloon-shine';
      body.appendChild(shine);

      var string = document.createElement('div');
      string.className = 'pt-aniv-balloon-string';

      balloon.appendChild(body);
      balloon.appendChild(string);
      wrap.appendChild(balloon);
    });

    setTimeout(function () {
      wrap.remove();
    }, 7000);
  }

  var ANIV_BANNER_KEY = 'pt_aniv_banner_dismissed';

  function injectMiniBanner() {
    if (localStorage.getItem(ANIV_BANNER_KEY) === '1') return;
    if (document.querySelector('.pt-aniv-minibanner')) return;

    var banner = document.createElement('div');
    banner.className = 'pt-aniv-minibanner';

    var img = document.createElement('img');
    img.src = 'https://cdn.shopify.com/s/files/1/0674/7737/2997/files/mini-banner-25.png?v=1784031916';
    img.alt = 'Aniversario Crower 25% OFF';
    img.className = 'pt-aniv-minibanner-img';

    var close = document.createElement('button');
    close.className = 'pt-aniv-minibanner-close';
    close.setAttribute('aria-label', 'Cerrar');
    close.textContent = '×';

    function dismiss() {
      localStorage.setItem(ANIV_BANNER_KEY, '1');
      banner.remove();
    }

    close.addEventListener('click', function (e) {
      e.stopPropagation();
      dismiss();
    });
    banner.addEventListener('click', dismiss);

    banner.appendChild(img);
    banner.appendChild(close);
    document.body.appendChild(banner);
  }

  function injectCollectionBadges() {
    var cards = document.querySelectorAll('[data-aniv-product="true"]');
    cards.forEach(function (card) {
      if (card.querySelector('.pt-aniv-card-badge')) return;
      var tagsEl = card.querySelector('.m-product-card__tags');
      if (!tagsEl) return;
      var badge = document.createElement('span');
      badge.className = 'pt-aniv-card-badge';
      badge.textContent = '-25% OFF';
      tagsEl.insertBefore(badge, tagsEl.firstChild);
    });
  }

  var ANIV_TOPBANNER_KEY = 'pt_aniv_topbanner_v2';

  function showTopBanner() {
    if (localStorage.getItem(ANIV_TOPBANNER_KEY) === '1') return;
    if (document.querySelector('.pt-aniv-top-banner')) return;

    var banner = document.createElement('div');
    banner.className = 'pt-aniv-top-banner';
    banner.setAttribute('role', 'banner');
    banner.setAttribute('aria-label', '3° Aniversario Crower');

    var s1 = document.createElement('span');
    s1.className = 'pt-aniv-top-banner__sparkle';
    s1.setAttribute('aria-hidden', 'true');
    s1.textContent = '✦';

    var text = document.createElement('span');
    text.className = 'pt-aniv-top-banner__text';
    text.innerHTML = 'Celebrando nuestro <strong class="pt-aniv-top-banner__hl">3° Aniversario</strong> — descuentos especiales en todo el catálogo';

    var s2 = document.createElement('span');
    s2.className = 'pt-aniv-top-banner__sparkle';
    s2.setAttribute('aria-hidden', 'true');
    s2.textContent = '✦';

    var closeBtn = document.createElement('button');
    closeBtn.className = 'pt-aniv-top-banner__close';
    closeBtn.setAttribute('aria-label', 'Cerrar');
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      localStorage.setItem(ANIV_TOPBANNER_KEY, '1');
      banner.style.display = 'none';
    });

    banner.appendChild(s1);
    banner.appendChild(text);
    banner.appendChild(s2);
    banner.appendChild(closeBtn);

    document.body.insertBefore(banner, document.body.firstChild);
  }

  function showHomeBanner() {
    document.querySelectorAll('.banner2home-aniversario').forEach(function (el) {
      el.style.display = 'block';
    });
    document.querySelectorAll('.banner2home-principal').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function formatCOPAniv(n) {
    return new Intl.NumberFormat('es-CO').format(Math.round(n));
  }

  function parseCOPPrice(text) {
    // "$16.016" → 16016
    var clean = String(text).replace(/[$\s.]/g, '').replace(',', '.');
    var n = parseInt(clean, 10);
    return isNaN(n) ? 0 : n;
  }

  function isAnivProduct(productId) {
    if (!productId) return false;
    var card = document.querySelector(
      '[data-product-id="' + productId + '"][data-aniv-product="true"]'
    );
    return !!card;
  }

  function cleanAniversarioModal(dialog) {
    // Remove badge
    var old = dialog.querySelector('.pt-aniv-modal-badge');
    if (old) old.remove();
    // Restore original prices
    dialog.querySelectorAll('.xcs-modal__price-value[data-aniv-applied]').forEach(function (el) {
      var orig = el.getAttribute('data-aniv-original');
      if (orig) el.textContent = orig;
      el.removeAttribute('data-aniv-applied');
      el.removeAttribute('data-aniv-original');
    });
  }

  function applyAniversarioModal(dialog) {
    if (!shouldShowAniversario()) return;
    cleanAniversarioModal(dialog);
    var productId = dialog.getAttribute('data-active-product-id');
    if (!isAnivProduct(productId)) return;

    // Badge in header (insert before close button)
    var header = dialog.querySelector('.xcs-modal__header');
    if (header) {
      var badge = document.createElement('span');
      badge.className = 'pt-aniv-modal-badge';
      badge.textContent = 'Producto con -25% OFF 🎉 ¡Feliz 3er Aniversario!';
      var closeBtn = header.querySelector('.xcs-modal__close');
      if (closeBtn) header.insertBefore(badge, closeBtn);
      else header.appendChild(badge);
    }

    // -25% on prices
    dialog.querySelectorAll('.xcs-modal__price-value').forEach(function (el) {
      var original = parseCOPPrice(el.textContent);
      if (!original) return;
      var discounted = Math.round(original * 0.75);
      el.setAttribute('data-aniv-original', el.textContent.trim());
      el.setAttribute('data-aniv-applied', '1');
      el.innerHTML =
        '<span class="pt-aniv-price-new">$' + formatCOPAniv(discounted) + '</span>' +
        '<span class="pt-aniv-price-old">$' + formatCOPAniv(original) + '</span>';
    });
  }

  function initAniversarioModal() {
    if (!shouldShowAniversario()) return;

    var applyPending = false;

    function scheduleApply(dialog) {
      if (applyPending) return;
      applyPending = true;
      setTimeout(function () {
        applyPending = false;
        applyAniversarioModal(dialog);
      }, 120);
    }

    function attachDialogObserver(dialog) {
      // Watch attribute changes (product switch / open)
      var attrObserver = new MutationObserver(function () {
        scheduleApply(dialog);
      });
      attrObserver.observe(dialog, { attributes: true, attributeFilter: ['data-active-product-id', 'open'] });

      // Watch direct children of dialog for price rows rendered
      var childObserver = new MutationObserver(function () {
        scheduleApply(dialog);
      });
      childObserver.observe(dialog, { childList: true, subtree: false });
    }

    var existing = document.getElementById('xcs-global-modal');
    if (existing) {
      attachDialogObserver(existing);
    } else {
      var docObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.id === 'xcs-global-modal') {
              docObserver.disconnect();
              attachDialogObserver(node);
              scheduleApply(node); // already open on first creation
            }
          });
        });
      });
      docObserver.observe(document.body, { childList: true });
    }
  }

  function watchCollectionBadges() {
    if (!shouldShowAniversario()) return;
    var grid = document.querySelector('.collection-products, .m-collection-products, [class*="collection"]');
    if (!grid) return;
    var obs = new MutationObserver(function () {
      injectCollectionBadges();
    });
    obs.observe(grid, { childList: true, subtree: true });
  }

  function initAniversarioEffects() {
    if (!shouldShowAniversario()) return;
    document.querySelectorAll('.banner_top_aniversario').forEach(function (el) {
      el.style.display = 'flex';
    });

    // Burst: esperar 2s para que la página ya esté visible, luego disparar
    setTimeout(function () {
      if (typeof window.ptShowLoginBurst === 'function') {
        window.ptShowLoginBurst();
      }
    }, 2000);

    showTopBanner();
    showHomeBanner();
    initAniversarioModal();
    injectMiniBanner();
    injectCollectionBadges();
    injectConfetti();
    injectBalloons();
    watchCollectionBadges();
  }

  function tryShowTopBannerOnLogin() {
    if (shouldShowAniversario()) showTopBanner();
  }
  window.addEventListener('krow-auth-change', tryShowTopBannerOnLogin);
  window.addEventListener('crow-auth-change', tryShowTopBannerOnLogin);
  window.addEventListener('crower-auth-change', tryShowTopBannerOnLogin);

  // Auth may resolve async after DOMContentLoaded — poll 10x/500ms = 5s
  var _pollCount = 0;
  var _pollId = setInterval(function () {
    _pollCount++;
    if (shouldShowAniversario()) {
      initAniversarioEffects();
      clearInterval(_pollId);
      return;
    }
    if (_pollCount >= 10) clearInterval(_pollId);
  }, 500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAniversarioEffects);
  } else {
    initAniversarioEffects();
  }

  window.CrowerAniversario = {
    isActive: isAniversarioActive,
    isLogged: isLogged,
    shouldShow: shouldShowAniversario
  };
})();
